module.exports = __webpack_public_path__ + "img/webeditor-3.dbd22b05.gif";